import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {ClickkerHttpClient} from "./ClickkerHttpClient";

@Injectable({
    providedIn: 'root'
})
export abstract class WatcherHttpClient extends ClickkerHttpClient {
    constructor() {
        super(environment.clickkerWatcher.api.url)
    }
}
